import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Row, Col, Container, Button } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import "swiper/swiper-bundle.css";
import {GetContentThunk } from "../../../store/redux/SLICE/auth/Content";
import { useDispatch,useSelector } from "react-redux";
import { BASE_URL } from '../../../BaseUrl';
import axios from "axios";
import { TMDB_CONFIG, getImageUrl, getPosterUrl } from "../../../config/tmdb";
import { toast } from "react-toastify";
import { CompactWatchlistButtons } from "../../../components/WatchlistButtons";

//img
import banner from "../../../assets/images/movie-banner/1.jpg";
import banner2 from "../../../assets/images/movie-banner/2.jpg";
import banner3 from "../../../assets/images/movie-banner/3.jpg";
import img1 from "../../../assets/images/upcoming/01.jpg";
import img2 from "../../../assets/images/upcoming/02.jpg";
import img3 from "../../../assets/images/upcoming/03.jpg";
import img4 from "../../../assets/images/upcoming/04.jpg";
import img5 from "../../../assets/images/upcoming/05.jpg";
import movie1 from "../../../assets/images/movies/01.jpg";
import movie2 from "../../../assets/images/movies/02.jpg";
import movie3 from "../../../assets/images/movies/03.jpg";
import movie4 from "../../../assets/images/movies/04.jpg";
import movie5 from "../../../assets/images/movies/05.jpg";
import movie6 from "../../../assets/images/movies/06.jpg";
import movie7 from "../../../assets/images/movies/07.jpg";
import movie8 from "../../../assets/images/movies/08.jpg";
import movie9 from "../../../assets/images/movies/09.jpg";
import movie10 from "../../../assets/images/movies/10.jpg";

// install Swiper modules
SwiperCore.use([Navigation]);

// TMDB API Service for Movie List
const fetchPopularMovies = async () => {
  try {
    // Check if JWT token is configured
    if (TMDB_CONFIG.JWT_TOKEN === 'YOUR_TMDB_JWT_TOKEN') {
      throw new Error('TMDB JWT token not configured. Please add your JWT token to the environment variables or config file.');
    }

    const url = `${TMDB_CONFIG.BASE_URL}${TMDB_CONFIG.ENDPOINTS.POPULAR_MOVIES}?language=en-US&page=1`;

    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${TMDB_CONFIG.JWT_TOKEN}`
      }
    };
    
    const response = await axios.request(options);
    return response.data;
  } catch (error) {
    console.error('Error fetching TMDB popular movies:', error);
    throw error;
  }
};

// Transform TMDB data to match component structure
const transformTMDBMovieData = (tmdbMovies) => {
  return tmdbMovies.results.map(movie => ({
    _id: movie.id.toString(),
    title: movie.title,
    contentName: movie.title,
    description: movie.overview,
    thumbnail_image: getImageUrl(movie.backdrop_path),
    poster_image: getPosterUrl(movie.poster_path),
    release_date: movie.release_date,
    vote_average: movie.vote_average,
    vote_count: movie.vote_count,
    adult: movie.adult,
    genre_ids: movie.genre_ids,
    original_language: movie.original_language,
    original_title: movie.original_title,
    popularity: movie.popularity,
    video: movie.video,
    // Add default values for fields that might not exist in TMDB
    ageLimit: movie.adult ? '18+' : '13+',
    duration: '2:30', // Default duration as TMDB doesn't provide runtime in popular movies
  }));
};

// TMDB Top Rated Movies API Service
const fetchTopRatedMovies = async () => {
  try {
    // Check if JWT token is configured
    if (TMDB_CONFIG.JWT_TOKEN === 'YOUR_TMDB_JWT_TOKEN') {
      throw new Error('TMDB JWT token not configured. Please add your JWT token to the environment variables or config file.');
    }

    const url = `${TMDB_CONFIG.BASE_URL}${TMDB_CONFIG.ENDPOINTS.TOP_RATED_MOVIES}?language=en-US&page=1`;

    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${TMDB_CONFIG.JWT_TOKEN}`
      }
    };
    
    const response = await axios.request(options);
    return response.data;
  } catch (error) {
    console.error('Error fetching TMDB top-rated movies:', error);
    throw error;
  }
};

// TMDB Now Playing Movies API Service
const fetchNowPlayingMovies = async () => {
  try {
    // Check if JWT token is configured
    if (TMDB_CONFIG.JWT_TOKEN === 'YOUR_TMDB_JWT_TOKEN') {
      throw new Error('TMDB JWT token not configured. Please add your JWT token to the environment variables or config file.');
    }

    const url = `${TMDB_CONFIG.BASE_URL}${TMDB_CONFIG.ENDPOINTS.NOW_PLAYING_MOVIES}?language=en-US&page=1`;

    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${TMDB_CONFIG.JWT_TOKEN}`
      }
    };
    
    const response = await axios.request(options);
    return response.data;
  } catch (error) {
    console.error('Error fetching TMDB now playing movies:', error);
    throw error;
  }
};

const MovieList = () => {

  const handleAddClick = (Data) => {
    toast.success(Data, {
      position: "top-right",
      autoClose: 3000, 
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const copyURL = () => {
    const url = window.location.href;
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = url;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    toast.success("URL copied to clipboard: " + url)
   
  };

  const dispatch = useDispatch();

  // TMDB API state management
  const [tmdbMovies, setTmdbMovies] = useState({
    movies: [],
    loading: false,
    error: null
  });

  // TMDB Top Rated Movies state management
  const [tmdbTopRatedMovies, setTmdbTopRatedMovies] = useState({
    movies: [],
    loading: false,
    error: null
  });

  // TMDB Now Playing Movies state management
  const [tmdbNowPlayingMovies, setTmdbNowPlayingMovies] = useState({
    movies: [],
    loading: false,
    error: null
  });

  // Fetch TMDB popular movies
  const fetchTMDBPopularMovies = async () => {
    setTmdbMovies(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchPopularMovies();
      const transformedData = transformTMDBMovieData(data);
      setTmdbMovies({
        movies: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Popular Movies fetched:", transformedData);
    } catch (error) {
      setTmdbMovies(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error("Failed to fetch TMDB popular movies:", error);
    }
  };

  // Fetch TMDB top-rated movies
  const fetchTMDBTopRatedMovies = async () => {
    setTmdbTopRatedMovies(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchTopRatedMovies();
      const transformedData = transformTMDBMovieData(data);
      setTmdbTopRatedMovies({
        movies: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Top Rated Movies fetched:", transformedData);
    } catch (error) {
      setTmdbTopRatedMovies(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error("Failed to fetch TMDB top-rated movies:", error);
    }
  };

  // Fetch TMDB now playing movies
  const fetchTMDBNowPlayingMovies = async () => {
    setTmdbNowPlayingMovies(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchNowPlayingMovies();
      const transformedData = transformTMDBMovieData(data);
      setTmdbNowPlayingMovies({
        movies: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Now Playing Movies fetched:", transformedData);
    } catch (error) {
      setTmdbNowPlayingMovies(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error("Failed to fetch TMDB now playing movies:", error);
    }
  };

  useEffect(() => {
    fetchTMDBPopularMovies();
    fetchTMDBTopRatedMovies();
    fetchTMDBNowPlayingMovies();
  }, []);

  
useEffect(() => {
  dispatch(GetContentThunk());
}, [dispatch]);


const store = useSelector((state)=>state);
console.log(store,"Sub User store")

const moviesContent=store && store?.contents?.contents
console.log(moviesContent,"moviesContent User store")

const handleLinkClick = () => {
  window.scrollTo(0, 0); 
};

  return (
    <>
      <section id="movieshow" className="iq-main-slider p-0">
        <div id="prev" className="swiper-button swiper-button-prev">
          <i className="ri-arrow-left-s-line"></i>
        </div>
        <div id="next" className="swiper-button swiper-button-next">
          <i className="ri-arrow-right-s-line"></i>
        </div>
        <Swiper
          slidesPerView={2}
          spaceBetween={0}
          centeredSlides={true}
          navigation={{
            prevEl: "#prev",
            nextEl: "#next",
          }}
          loop={true}
          className=""
        >
          {tmdbMovies.loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{height: '400px', width: '100%'}}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : tmdbMovies.error ? (
            <div className="d-flex justify-content-center align-items-center" style={{height: '400px', width: '100%'}}>
              <div className="text-center">
                <h3 className="text-white">Error Loading Movies</h3>
                <p className="text-white-50">{tmdbMovies.error}</p>
                <button 
                  className="btn btn-primary mt-3" 
                  onClick={fetchTMDBPopularMovies}
                >
                  Retry
                </button>
              </div>
            </div>
          ) : tmdbMovies.movies && tmdbMovies.movies.length > 0 ? (
            tmdbMovies.movies.slice(0, 6).map((movie, index) => (
              <SwiperSlide key={movie._id || index}>
                <Link to={`/movie-details/${movie._id}`}>
                  <div className="shows-img" style={{ height: '95vh', position: 'relative' }}>
                    <img 
                      src={movie.poster_image || 'https://via.placeholder.com/300x450/333/fff?text=No+Image'} 
                      className="w-100 img" 
                      alt={movie.title}
                      style={{
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center'
                      }}
                    />
                    <div className="shows-content">
                      <h4 className="text-white mb-1">{movie.title}</h4>
                      <div className="movie-time d-flex align-items-center">
                        <div className="badge badge-secondary p-1 mr-2">{movie.ageLimit}</div>
                        <span className="text-white">{movie.duration}</span>
                      </div>
                      <div className="category-page">
                        <div className="slider-ratting d-flex align-items-center mr-4 mt-0 mt-md-3">
                          <ul className="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left">
                            <li><i className="fa fa-star" aria-hidden="true"></i></li>
                            <li><i className="fa fa-star" aria-hidden="true"></i></li>
                            <li><i className="fa fa-star" aria-hidden="true"></i></li>
                            <li><i className="fa fa-star" aria-hidden="true"></i></li>
                            <li><i className="fa fa-star-half" aria-hidden="true"></i></li>
                          </ul>
                          <span className="text-white ml-2">
                            {movie.vote_average ? movie.vote_average.toFixed(1) : 'N/A'}(TMDB)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))
          ) : (
            <div className="d-flex justify-content-center align-items-center" style={{height: '400px', width: '100%'}}>
              <div className="text-center">
                <h3 className="text-white">No Movies Available</h3>
                <p className="text-white-50">Please check back later for new movies.</p>
              </div>
            </div>
          )}
        </Swiper>
      </section>
      <div className="d-block">
        <Dropdown className="genres-box">
          <Dropdown.Toggle as={Button} variant="secondary">
            Genres
          </Dropdown.Toggle>
          <Dropdown.Menu className="three-column">
            <Dropdown.Item href="#">Hindi</Dropdown.Item>
            <Dropdown.Item href="#">Tamil</Dropdown.Item>
            <Dropdown.Item href="#">Punjabi</Dropdown.Item>
            <Dropdown.Item href="#">English</Dropdown.Item>
            <Dropdown.Item href="#">Comedies</Dropdown.Item>
            <Dropdown.Item href="#">Action</Dropdown.Item>
            <Dropdown.Item href="#">Romance</Dropdown.Item>
            <Dropdown.Item href="#">Dramas</Dropdown.Item>
            <Dropdown.Item href="#">Bollywood</Dropdown.Item>
            <Dropdown.Item href="#">Hollywood</Dropdown.Item>
            <Dropdown.Item href="#">Children & Family</Dropdown.Item>
            <Dropdown.Item href="#">Award-Winning</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="main-content">
        <section id="iq-favorites-top-rated">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">Top Rated Movies</h4>
                </div>
                <div id="favorites-contens">
                  <div id="prev1" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next1" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    spaceBetween={20}
                    slidesPerView={4}
                    navigation={{
                      prevEl: "#prev1",
                      nextEl: "#next1",
                    }}
                    loop={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    className="favorites-slider list-inline  row p-0 m-0 iq-rtl-direction"
                  >
                    {tmdbTopRatedMovies.loading ? (
                      <div className="d-flex justify-content-center align-items-center" >
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : tmdbTopRatedMovies.error ? (
                      <div className="d-flex justify-content-center align-items-center" >
                        <div className="text-center">
                          <h3 className="text-white">Error Loading Movies</h3>
                          <p className="text-white-50">{tmdbTopRatedMovies.error}</p>
                          <button 
                            className="btn btn-primary mt-3" 
                            onClick={fetchTMDBTopRatedMovies}
                          >
                            Retry
                          </button>
                        </div>
                      </div>
                    ) : tmdbTopRatedMovies.movies && tmdbTopRatedMovies.movies.length > 0 ? (
                      tmdbTopRatedMovies.movies.slice(0, 10).map((movie, index) => (
                        <SwiperSlide key={movie._id || index} className="slide-item">
                          <div className="block-images1 block-images position-relative">
                            <div className="img-box">
                              <img
                                src={movie.poster_image || 'https://via.placeholder.com/300x450/333/fff?text=No+Image'}
                                className="img-fluid"
                                style={{height: '200px', width: '100%', objectFit: 'cover'}}
                                alt={movie.title}
                               
                              />
                            </div>
                            <div className="block-description">
                              <h6 className="iq-title">
                                <Link to={`/movie-details/${movie._id}`}>{movie.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {movie.ageLimit}
                                </div>
                                <span className="text-white">{movie.duration}</span>
                              </div>
                              <div className="category-page">
                                <div className="slider-ratting d-flex align-items-center mr-4 mt-0 mt-md-3">
                                  <ul className="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left">
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star-half" aria-hidden="true"></i></li>
                                  </ul>
                                  <span className="text-white ml-2">
                                    {movie.vote_average ? movie.vote_average.toFixed(1) : 'N/A'}(TMDB)
                                  </span>
                                </div>
                              </div>
                              <div className="hover-buttons">
                                <Link
                                  to={`/movie-details/${movie._id}`}
                                  role="button"
                                  className="btn btn-hover"
                                >
                                  <i className="fa fa-play mr-1" aria-hidden="true"></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                      <a
                                        href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-facebook-fill"></i>
                                      </a>
                                      <a
                                        href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-twitter-fill"></i>
                                      </a>
                                      <a
                                        href="#"
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        className="share-ico iq-copy-link"
                                        tabIndex="0"
                                      >
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(movie._id),
                                  title: movie.title,
                                  type: 'movie',
                                  poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                                  imgSrc: movie.poster_image,
                                  vote_average: movie.vote_average,
                                  release_date: movie.release_date,
                                  overview: movie.overview,
                                  adult: movie.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="text-center">
                          <h3 className="text-white">No Movies Available</h3>
                          <p className="text-white-50">Please check back later for new movies.</p>
                        </div>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section id="iq-favorites-popular-movies">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">Popular Movies</h4>
                </div>
                <div id="favorites-contens">
                  <div id="prev2" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next2" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    spaceBetween={20}
                    slidesPerView={4}
                    navigation={{
                      prevEl: "#prev2",
                      nextEl: "#next2",
                    }}
                    loop={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    className="favorites-slider list-inline  row p-0 m-0 iq-rtl-direction"
                  >
                    {tmdbMovies.loading ? (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : tmdbMovies.error ? (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="text-center">
                          <h3 className="text-white">Error Loading Movies</h3>
                          <p className="text-white-50">{tmdbMovies.error}</p>
                          <button 
                            className="btn btn-primary mt-3" 
                            onClick={fetchTMDBPopularMovies}
                          >
                            Retry
                          </button>
                        </div>
                      </div>
                    ) : tmdbMovies.movies && tmdbMovies.movies.length > 0 ? (
                      tmdbMovies.movies.slice(0, 8).map((movie, index) => (
                        <SwiperSlide key={movie._id || index} className="slide-item">
                          <div className="block-images1 block-images position-relative">
                            <div className="img-box">
                              <img
                                src={movie.poster_image || 'https://via.placeholder.com/300x450/333/fff?text=No+Image'}
                                className="img-fluid"
                                alt={movie.title}
                                style={{height: '200px', width: '100%', objectFit: 'cover'}}
                              />
                            </div>
                            <div className="block-description">
                              <h6 className="iq-title">
                                <Link to={`/movie-details/${movie._id}`}>{movie.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {movie.ageLimit}
                                </div>
                                <span className="text-white">{movie.duration}</span>
                              </div>
                              <div className="category-page">
                                <div className="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3">
                                  <ul className="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left">
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star-half" aria-hidden="true"></i></li>
                                  </ul>
                                  <span className="text-white ml-2">
                                    {movie.vote_average ? movie.vote_average.toFixed(1) : 'N/A'}(TMDB)
                                  </span>
                                </div>
                              </div>
                              <div className="hover-buttons">
                                <Link
                                  to={`/movie-details/${movie._id}`}
                                  role="button"
                                  className="btn btn-hover"
                                >
                                  <i className="fa fa-play mr-1" aria-hidden="true"></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                      <a
                                        href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-facebook-fill"></i>
                                      </a>
                                      <a
                                        href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-twitter-fill"></i>
                                      </a>
                                      <a
                                        href="#"
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        className="share-ico iq-copy-link"
                                        tabIndex="0"
                                      >
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(movie._id),
                                  title: movie.title,
                                  type: 'movie',
                                  poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                                  imgSrc: movie.poster_image,
                                  vote_average: movie.vote_average,
                                  release_date: movie.release_date,
                                  overview: movie.overview,
                                  adult: movie.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="text-center">
                          <h3 className="text-white">No Movies Available</h3>
                          <p className="text-white-50">Please check back later for new movies.</p>
                        </div>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section id="iq-upcoming-movie">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">Now Playing Movies</h4>
                </div>
                <div id="upcoming-contens">
                  <div id="prev3" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next3" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    navigation={{
                      prevEl: "#prev3",
                      nextEl: "#next3",
                    }}
                    loop={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                  >
                    {tmdbNowPlayingMovies.loading ? (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : tmdbNowPlayingMovies.error ? (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="text-center">
                          <h3 className="text-white">Error Loading Movies</h3>
                          <p className="text-white-50">{tmdbNowPlayingMovies.error}</p>
                          <button 
                            className="btn btn-primary mt-3" 
                            onClick={fetchTMDBNowPlayingMovies}
                          >
                            Retry
                          </button>
                        </div>
                      </div>
                    ) : tmdbNowPlayingMovies.movies && tmdbNowPlayingMovies.movies.length > 0 ? (
                      tmdbNowPlayingMovies.movies.slice(0, 8).map((movie, index) => (
                        <SwiperSlide key={movie._id || index} className="slide-item">
                          <div className="block-images1 block-images position-relative">
                            <div className="img-box">
                              <img
                                src={movie.poster_image || 'https://via.placeholder.com/300x450/333/fff?text=No+Image'}
                                className="img-fluid"
                                alt={movie.title}
                                style={{height: '200px', width: '100%', objectFit: 'cover'}}
                              />
                            </div>
                            <div className="block-description">
                              <h6 className="iq-title">
                                <Link to={`/movie-details/${movie._id}`}>{movie.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {movie.ageLimit}
                                </div>
                                <span className="text-white">{movie.duration}</span>
                              </div>
                              <div className="category-page">
                                <div className="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3">
                                  <ul className="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left">
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star-half" aria-hidden="true"></i></li>
                                  </ul>
                                  <span className="text-white ml-2">
                                    {movie.vote_average ? movie.vote_average.toFixed(1) : 'N/A'}(TMDB)
                                  </span>
                                </div>
                              </div>
                              <div className="hover-buttons">
                                <Link
                                  to={`/movie-details/${movie._id}`}
                                  role="button"
                                  className="btn btn-hover"
                                >
                                  <i className="fa fa-play mr-1" aria-hidden="true"></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                      <a
                                        href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-facebook-fill"></i>
                                      </a>
                                      <a
                                        href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-twitter-fill"></i>
                                      </a>
                                      <a
                                        href="#"
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        className="share-ico iq-copy-link"
                                        tabIndex="0"
                                      >
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(movie._id),
                                  title: movie.title,
                                  type: 'movie',
                                  poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                                  imgSrc: movie.poster_image,
                                  vote_average: movie.vote_average,
                                  release_date: movie.release_date,
                                  overview: movie.overview,
                                  adult: movie.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="text-center">
                          <h3 className="text-white">No Movies Available</h3>
                          <p className="text-white-50">Please check back later for new movies.</p>
                        </div>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* <section id="iq-suggestede">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">Movies Recommended for you</h4>
                </div>
                <div id="suggestede-contens">
                  <div id="prev4" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next4" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    navigation={{
                      prevEl: "#prev4",
                      nextEl: "#next4",
                    }}
                    loop={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    className="list-inline favorites-slider row p-0 m-0 iq-rtl-direction"
                  >
                    <SwiperSlide className="slide-item">
                      <div className="block-images1 block-images position-relative">
                        <div className="img-box">
                          <img src={movie6} className="img-fluid" alt="" />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">The Lost Journey</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2">
                            <div className="badge badge-secondary p-1 mr-2">
                              20+
                            </div>
                            <span className="text-white">2h 15m</span>
                          </div>
                          <div className="category-page">
                            <div
                              class="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                              data-iq-gsap="onStart"
                              data-iq-position-x="-200"
                              data-iq-delay="-0.5"
                              // style="transform: translate(0px, 0px);opacity: 1;"
                              speechify-initial-font-family="Roboto, sans-serif"
                              speechify-initial-font-size="16px"
                            >
                              <ul
                                class="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="16px"
                              >
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star-half"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                              </ul>
                              <span
                                class="text-white ml-2"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="14px"
                              >
                                4.7(lmdb)
                              </span>
                            </div>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    to="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <CompactWatchlistButtons item={{
                              id: parseInt(movie._id),
                              title: movie.title,
                              type: 'movie',
                              poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                              imgSrc: movie.poster_image,
                              vote_average: movie.vote_average,
                              release_date: movie.release_date,
                              overview: movie.overview,
                              adult: movie.adult
                            }} />
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="slide-item">
                      <div className=" block-images position-relative">
                        <div className="img-box">
                          <img src={movie7} className="img-fluid" alt="" />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">Boop Bitty</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2">
                            <div className="badge badge-secondary p-1 mr-2">
                              11+
                            </div>
                            <span className="text-white">2h 30m</span>
                          </div>
                          <div className="category-page">
                            <div
                              class="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                              data-iq-gsap="onStart"
                              data-iq-position-x="-200"
                              data-iq-delay="-0.5"
                              // style="transform: translate(0px, 0px);opacity: 1;"
                              speechify-initial-font-family="Roboto, sans-serif"
                              speechify-initial-font-size="16px"
                            >
                              <ul
                                class="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="16px"
                              >
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star-half"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                              </ul>
                              <span
                                class="text-white ml-2"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="14px"
                              >
                                4.7(lmdb)
                              </span>
                            </div>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <CompactWatchlistButtons item={{
                              id: parseInt(movie._id),
                              title: movie.title,
                              type: 'movie',
                              poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                              imgSrc: movie.poster_image,
                              vote_average: movie.vote_average,
                              release_date: movie.release_date,
                              overview: movie.overview,
                              adult: movie.adult
                            }} />
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="slide-item">
                      <div className=" block-images position-relative">
                        <div className="img-box">
                          <img src={movie8} className="img-fluid" alt="" />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">Unknown Land</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2">
                            <div className="badge badge-secondary p-1 mr-2">
                              17+
                            </div>
                            <span className="text-white">2h 30m</span>
                          </div>
                          <div className="category-page">
                            <div
                              class="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                              data-iq-gsap="onStart"
                              data-iq-position-x="-200"
                              data-iq-delay="-0.5"
                              // style="transform: translate(0px, 0px);opacity: 1;"
                              speechify-initial-font-family="Roboto, sans-serif"
                              speechify-initial-font-size="16px"
                            >
                              <ul
                                class="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="16px"
                              >
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star-half"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                              </ul>
                              <span
                                class="text-white ml-2"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="14px"
                              >
                                4.7(lmdb)
                              </span>
                            </div>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <li>
                              <span onClick={()=>handleAddClick('Liked Successfully !')}> 
                                <i className="ri-heart-fill"></i>
                              </span>
                              <span className="count-box">19+</span>
                            </li>
                            <li>
                              <span  onClick={()=>handleAddClick('Added Successfully !')}>
                                <i className="ri-add-line"></i>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="slide-item">
                      <div className="block-images position-relative">
                        <div className="img-box">
                          <img src={movie9} className="img-fluid" alt="" />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">Blood Block</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2">
                            <div className="badge badge-secondary p-1 mr-2">
                              13+
                            </div>
                            <span className="text-white">2h 30m</span>
                          </div>
                          <div className="category-page">
                            <div
                              class="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                              data-iq-gsap="onStart"
                              data-iq-position-x="-200"
                              data-iq-delay="-0.5"
                              // style="transform: translate(0px, 0px);opacity: 1;"
                              speechify-initial-font-family="Roboto, sans-serif"
                              speechify-initial-font-size="16px"
                            >
                              <ul
                                class="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="16px"
                              >
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star-half"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                              </ul>
                              <span
                                class="text-white ml-2"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="14px"
                              >
                                4.7(lmdb)
                              </span>
                            </div>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <CompactWatchlistButtons item={{
                              id: parseInt(movie._id),
                              title: movie.title,
                              type: 'movie',
                              poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                              imgSrc: movie.poster_image,
                              vote_average: movie.vote_average,
                              release_date: movie.release_date,
                              overview: movie.overview,
                              adult: movie.adult
                            }} />
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="slide-item">
                      <div className="block-images position-relative">
                        <div className="img-box">
                          <img src={movie10} className="img-fluid" alt="" />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">Champions</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2">
                            <div className="badge badge-secondary p-1 mr-2">
                              13+
                            </div>
                            <span className="text-white">2h 30m</span>
                          </div>
                          <div className="category-page">
                            <div
                              class="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                              data-iq-gsap="onStart"
                              data-iq-position-x="-200"
                              data-iq-delay="-0.5"
                              // style="transform: translate(0px, 0px);opacity: 1;"
                              speechify-initial-font-family="Roboto, sans-serif"
                              speechify-initial-font-size="16px"
                            >
                              <ul
                                class="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="16px"
                              >
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star-half"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                              </ul>
                              <span
                                class="text-white ml-2"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="14px"
                              >
                                4.7(lmdb)
                              </span>
                            </div>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <CompactWatchlistButtons item={{
                              id: parseInt(movie._id),
                              title: movie.title,
                              type: 'movie',
                              poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                              imgSrc: movie.poster_image,
                              vote_average: movie.vote_average,
                              release_date: movie.release_date,
                              overview: movie.overview,
                              adult: movie.adult
                            }} />
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section> */}
        {/* <section id="iq-suggestede content detail">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">Content Detail Screen</h4>
                </div>
                <div id="suggestede-contens">
                  <div id="prev5" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next5" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    navigation={{
                      prevEl: "#prev5",
                      nextEl: "#next5",
                    }}
                    loop={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    className="list-inline favorites-slider row p-0 m-0 iq-rtl-direction"
                  >
                    <SwiperSlide className="slide-item">
                      <div className="block-images1 block-images position-relative">
                        <div className="img-box">
                          <img src={movie8} className="img-fluid" alt="" />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">The Lost Journey</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2">
                            <div className="badge badge-secondary p-1 mr-2">
                              20+
                            </div>
                            <span className="text-white">2h 15m</span>
                          </div>
                          <div className="category-page">
                            <div
                              class="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                              data-iq-gsap="onStart"
                              data-iq-position-x="-200"
                              data-iq-delay="-0.5"
                              // style="transform: translate(0px, 0px);opacity: 1;"
                              speechify-initial-font-family="Roboto, sans-serif"
                              speechify-initial-font-size="16px"
                            >
                              <ul
                                class="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="16px"
                              >
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star-half"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                              </ul>
                              <span
                                class="text-white ml-2"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="14px"
                              >
                                4.7(lmdb)
                              </span>
                            </div>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <CompactWatchlistButtons item={{
                              id: parseInt(movie._id),
                              title: movie.title,
                              type: 'movie',
                              poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                              imgSrc: movie.poster_image,
                              vote_average: movie.vote_average,
                              release_date: movie.release_date,
                              overview: movie.overview,
                              adult: movie.adult
                            }} />
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="slide-item">
                      <div className=" block-images position-relative">
                        <div className="img-box">
                          <img src={movie6} className="img-fluid" alt="" />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">Boop Bitty</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2">
                            <div className="badge badge-secondary p-1 mr-2">
                              11+
                            </div>
                            <span className="text-white">2h 30m</span>
                          </div>
                          <div className="category-page">
                            <div
                              class="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                              data-iq-gsap="onStart"
                              data-iq-position-x="-200"
                              data-iq-delay="-0.5"
                              // style="transform: translate(0px, 0px);opacity: 1;"
                              speechify-initial-font-family="Roboto, sans-serif"
                              speechify-initial-font-size="16px"
                            >
                              <ul
                                class="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="16px"
                              >
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star-half"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                              </ul>
                              <span
                                class="text-white ml-2"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="14px"
                              >
                                4.7(lmdb)
                              </span>
                            </div>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <CompactWatchlistButtons item={{
                              id: parseInt(movie._id),
                              title: movie.title,
                              type: 'movie',
                              poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                              imgSrc: movie.poster_image,
                              vote_average: movie.vote_average,
                              release_date: movie.release_date,
                              overview: movie.overview,
                              adult: movie.adult
                            }} />
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="slide-item">
                      <div className=" block-images position-relative">
                        <div className="img-box">
                          <img src={movie7} className="img-fluid" alt="" />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">Unknown Land</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2">
                            <div className="badge badge-secondary p-1 mr-2">
                              17+
                            </div>
                            <span className="text-white">2h 30m</span>
                          </div>
                          <div className="category-page">
                            <div
                              class="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                              data-iq-gsap="onStart"
                              data-iq-position-x="-200"
                              data-iq-delay="-0.5"
                              // style="transform: translate(0px, 0px);opacity: 1;"
                              speechify-initial-font-family="Roboto, sans-serif"
                              speechify-initial-font-size="16px"
                            >
                              <ul
                                class="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="16px"
                              >
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star-half"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                              </ul>
                              <span
                                class="text-white ml-2"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="14px"
                              >
                                4.7(lmdb)
                              </span>
                            </div>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <CompactWatchlistButtons item={{
                              id: parseInt(movie._id),
                              title: movie.title,
                              type: 'movie',
                              poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                              imgSrc: movie.poster_image,
                              vote_average: movie.vote_average,
                              release_date: movie.release_date,
                              overview: movie.overview,
                              adult: movie.adult
                            }} />
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="slide-item">
                      <div className="block-images position-relative">
                        <div className="img-box">
                          <img src={movie9} className="img-fluid" alt="" />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">Blood Block</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2">
                            <div className="badge badge-secondary p-1 mr-2">
                              13+
                            </div>
                            <span className="text-white">2h 30m</span>
                          </div>
                          <div className="category-page">
                            <div
                              class="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                              data-iq-gsap="onStart"
                              data-iq-position-x="-200"
                              data-iq-delay="-0.5"
                              // style="transform: translate(0px, 0px);opacity: 1;"
                              speechify-initial-font-family="Roboto, sans-serif"
                              speechify-initial-font-size="16px"
                            >
                              <ul
                                class="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="16px"
                              >
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star-half"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                              </ul>
                              <span
                                class="text-white ml-2"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="14px"
                              >
                                4.7(lmdb)
                              </span>
                            </div>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <CompactWatchlistButtons item={{
                              id: parseInt(movie._id),
                              title: movie.title,
                              type: 'movie',
                              poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                              imgSrc: movie.poster_image,
                              vote_average: movie.vote_average,
                              release_date: movie.release_date,
                              overview: movie.overview,
                              adult: movie.adult
                            }} />
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="slide-item">
                      <div className="block-images position-relative">
                        <div className="img-box">
                          <img src={movie10} className="img-fluid" alt="" />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">Champions</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2">
                            <div className="badge badge-secondary p-1 mr-2">
                              13+
                            </div>
                            <span className="text-white">2h 30m</span>
                          </div>
                          <div className="category-page">
                            <div
                              class="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3"
                              data-iq-gsap="onStart"
                              data-iq-position-x="-200"
                              data-iq-delay="-0.5"
                              // style="transform: translate(0px, 0px);opacity: 1;"
                              speechify-initial-font-family="Roboto, sans-serif"
                              speechify-initial-font-size="16px"
                            >
                              <ul
                                class="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="16px"
                              >
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                                <li
                                  speechify-initial-font-family="Roboto, sans-serif"
                                  speechify-initial-font-size="16px"
                                >
                                  <i
                                    class="fa fa-star-half"
                                    aria-hidden="true"
                                    speechify-initial-font-family="FontAwesome"
                                    speechify-initial-font-size="16px"
                                  ></i>
                                </li>
                              </ul>
                              <span
                                class="text-white ml-2"
                                speechify-initial-font-family="Roboto, sans-serif"
                                speechify-initial-font-size="14px"
                              >
                                4.7(lmdb)
                              </span>
                            </div>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <CompactWatchlistButtons item={{
                              id: parseInt(movie._id),
                              title: movie.title,
                              type: 'movie',
                              poster_path: movie.poster_image?.includes('tmdb.org') ? movie.poster_image.split('/').pop() : null,
                              imgSrc: movie.poster_image,
                              vote_average: movie.vote_average,
                              release_date: movie.release_date,
                              overview: movie.overview,
                              adult: movie.adult
                            }} />
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section> */}
      </div>
    </>
  );
};
export default MovieList;
